<template>
  <div>
    <v-radio-group
      outlined
      dense
      v-model="innerValue"
      :readonly="readOnly"
    >
      <v-radio
        v-for="(option, index) in options"
        :key="'option' + index"
        :value="option.option_id"
        :readonly="readOnly"
        :label="option.option"
      />
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: "RadioGroupInput",

  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    readOnly: Boolean
  },

  data() {
    return {
      innerValue: this.modelValue
    }
  },

  watch: {
    modelValue(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit("update:modelValue", val)
    }
  }
}
</script>
